<template>
  <v-select
    :items="trainings"
    item-value="id"
    class="mb-2"
    item-text="name"
    v-model="selectedTraining"
    label="Eğitim"
    :rules="[(v) => !!v || 'Eğitim alanı boş bırakılamaz']"
    :loading="loading"
  >
  </v-select>
</template>

<script>
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import { FETCH_TRAININGS } from "@/core/services/store/definitions/trainings.module";

export default defineComponent({
  name: "SM-Education-Selectbox",
  props: {
    value: {
      type: Number,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  async beforeMount() {
    await this.fetchTrainings();
    this.loading = false;
  },
  data() {
    return {
      selectedTraining: this.value,
      loading: true,
    };
  },
  methods: {
    ...mapActions([FETCH_TRAININGS]),
  },
  computed: {
    ...mapGetters(["trainings"]),
  },
  watch: {
    selectedTraining: {
      immediate: true,
      handler(val) {
        this.$emit("update:value", val);
      },
    },
  },
});
</script>
